import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f548d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-score-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "layout-inner -top-and-bottom"
}
const _hoisted_3 = { class: "season-game-score-content" }
const _hoisted_4 = { class: "game-detail-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("試合情報 ")
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-file icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("スコアを表示 ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-clipboard-alt icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("スコアボード ")
const _hoisted_13 = { class: "global-message -border" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-info-icon icon" }, null, -1))
const _hoisted_15 = { class: "text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "_pcDisp" }, [
  /*#__PURE__*/_createTextVNode("この画面でゴールを追加・削除しても試合のスコアは変更されません。"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 試合のスコアを変更する必要がある場合は、 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("試合情報")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("から行ってください。 ")
const _hoisted_20 = {
  key: 0,
  class: "score-board-container"
}
const _hoisted_21 = { class: "score-team-summary" }
const _hoisted_22 = ["data-selected"]
const _hoisted_23 = { class: "name" }
const _hoisted_24 = ["data-selected"]
const _hoisted_25 = { class: "name" }
const _hoisted_26 = { class: "score-team-container" }
const _hoisted_27 = { class: "score-team-detail" }
const _hoisted_28 = { class: "score-team-detail" }
const _hoisted_29 = {
  key: 1,
  class: "score-board-container"
}
const _hoisted_30 = { class: "global-empty-text" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("試合情報")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" で対戦チームを選択してください。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ScoreBoard = _resolveComponent("ScoreBoard")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
      (_ctx.game.data != undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: {
              name: 'seasonGameDetail',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
              query: { group: _ctx.game.data.group_id } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("a", {
                  href: _ctx.scoreSheetUrl,
                  class: "link link-scoresheet",
                  target: "_blank"
                }, _hoisted_10, 8, _hoisted_7),
                _createVNode(_component_router_link, {
                  class: "link",
                  to: {
              name: 'seasonGameScoreboard',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id, } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("p", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17,
                  _createVNode(_component_router_link, {
                    class: "link",
                    to: {
                name: 'seasonGameDetail',
                params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
                query: { group: _ctx.game.data.group_id } }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_19
                ])
              ]),
              (_ctx.game.data.home && _ctx.game.data.away)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "team-tab-button",
                        "data-selected": _ctx.scoreTab.id === 'home',
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeScoreTab('home')))
                      }, [
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.game.data.home.team_name) + " " + _toDisplayString(_ctx.game.data.home.division), 1)
                      ], 8, _hoisted_22),
                      _createElementVNode("button", {
                        type: "button",
                        class: "team-tab-button",
                        "data-selected": _ctx.scoreTab.id === 'away',
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeScoreTab('away')))
                      }, [
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.game.data.away.team_name) + " " + _toDisplayString(_ctx.game.data.away.division), 1)
                      ], 8, _hoisted_24)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ScoreBoard, {
                          teamType: "home",
                          game: _ctx.game.data,
                          events: _ctx.events.home,
                          rosters: _ctx.rosters.home,
                          onOnClickEventButton: _ctx.addGameEvent,
                          onOnChangeEvent: _ctx.updateGameEvent,
                          onOnClickDeleteButton: _ctx.openEventDialogDelete
                        }, null, 8, ["game", "events", "rosters", "onOnClickEventButton", "onOnChangeEvent", "onOnClickDeleteButton"])
                      ], 512), [
                        [_vShow, !_ctx.mediaQuery.isMobile || _ctx.scoreTab.id === 'home']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_ScoreBoard, {
                          teamType: "away",
                          game: _ctx.game.data,
                          events: _ctx.events.away,
                          rosters: _ctx.rosters.away,
                          onOnClickEventButton: _ctx.addGameEvent,
                          onOnChangeEvent: _ctx.updateGameEvent,
                          onOnClickDeleteButton: _ctx.openEventDialogDelete
                        }, null, 8, ["game", "events", "rosters", "onOnClickEventButton", "onOnChangeEvent", "onOnClickDeleteButton"])
                      ], 512), [
                        [_vShow, !_ctx.mediaQuery.isMobile || _ctx.scoreTab.id === 'away']
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, [
                      _createVNode(_component_router_link, {
                        to: {
                name: 'seasonGameDetail',
                params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
                query: { group: _ctx.game.data.group_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_32
                    ])
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.eventDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.eventDialogDelete,
          onCloseDialog: _ctx.closeEventDialogDelete,
          onOnConfirm: _ctx.deleteGameEvent
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}